import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import proto from '../../Images/proto.png';
import proto2 from '../../Images/proto2.png';

export default function Dribble(){
    const [media, setMedia] = useState({
        matches: window.matchMedia("(max-width: 1180px)").matches
    });
    useEffect(()=> {
        const handler = e => setMedia({matches: e.matches});
        window.matchMedia("(max-width: 1180px)").addListener(handler);
    },[]);
    return(
        <div className="prototypes">
            {media.matches && (
            <div>
            <div className="Dribbble">
                <div className="content" data-aos="fade-up">
                    <div className="content-data">
                        <h2 className="proto-head">Amazing Contents</h2>
                        <h2 className="proto-head t3">loved by everyone</h2>
                        <p className="proto-para">I shared my designs, layouts, websites and interactive posts.</p>
                        <a href="https://dribbble.com/vikalp2502"><button className="social-btn">View Dribbble</button></a>
                    </div>
                </div>
                <div className="protolog" data-aos="fade-up">
                    <img src={proto} className="proto" />
                </div>
            </div>
            <div className="Instagram t4">
                <div className="content" data-aos="fade-up">
                    <div className="content-data">
                        <h2 className="proto-head">New Community</h2>
                        <h2 className="proto-head t3">of Instagram</h2>
                        <p className="proto-para">20+ posts to help young developers with context.</p>
                        <a href="https://instagram.com/vikalp._.kaushik"><button className="social-btn">View Instagram</button></a>
                    </div>
                </div>
                <div className="protolog" data-aos="fade-up">
                    <img src={proto2} className="proto2" />
                </div>
            </div>
            </div>
            )}
            {!media.matches && (
                <div>
                <div className="Dribbble">
                    <div className="content">
                        <div className="content-data">
                            <h2 className="proto-head">Amazing Contents</h2>
                            <h2 className="proto-head t3">loved by everyone</h2>
                            <p className="proto-para">I shared my designs, layouts, websites and interactive posts.</p>
                            <a href="https://dribbble.com/vikalp2502"><button className="social-btn">View Dribbble</button></a>
                        </div>
                    </div>
                    <div className="protolog">
                        <img src={proto} className="proto" />
                    </div>
                </div>
                <div className="Instagram t4">
                <div className="protolog">
                    <img src={proto2} className="proto2" />
                </div>
                <div className="content">
                    <div className="content-data">
                        <h2 className="proto-head">New Community</h2>
                        <h2 className="proto-head t3">of Instagram</h2>
                        <p className="proto-para">20+ posts to help young developers with context.</p>
                        <a href="https://instagram.com/vikalp._.kaushik"><button className="social-btn">View Instagram</button></a>
                    </div>
                </div>
            </div>
            </div>
            )}
        </div>
    )
}